import {createTableState, normalizePagination} from '@/core/services/Helper'

const state = () => ({
    table: createTableState(),
    filterData: undefined,
})

const getters = {}

const actions = {
    async get({state, commit}, {page, filterData}) {
        commit('setLoading', true)
        state.filterData = filterData
        let params = {page: page?.current, page_limit: page?.pageSize}
        if (state.filterData) params = {...params, ...state.filterData}

        const res = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_product_offer'), {params})
        const {data, meta} = res.data
        commit('updateTableData', data)
        commit('updatePagination', normalizePagination(meta))
        setTimeout(() => commit('setLoading', false), 250)
    },

    refresh({state, dispatch}) {
        dispatch('get', {page: state.table.pagination, filterData: state.filterData})
    },

    // productId'nin cross/up-sell önerileri
    async show({commit}, {id}) {
        const response = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_product_offer') + '/' + id)
        return response.data.data
    },

    // yeni: {product_id, cross_sell, up_sell}
    async create({commit}, {data}) {
        const response = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_product_offer'), data)
        return response.data
    },

    // güncelle: /{productId} {cross_sell, up_sell}
    async update({commit}, {id, data}) {
        const response = await this._vm.axios.put(this._vm.endpoint.get('ecommerce_product_offer') + '/' + id, data)
        return response.data
    },

    async delete({dispatch}, {id}) {
        let successDeleted = []
        if (!id || id.length === 0) {
            this._vm.$message.warning(this._vm.$t('messages.selectRow'))
        } else {
            for (let i = 0; i < id.length; i++) {
                const {data} = await this._vm.axios.delete(this._vm.endpoint.get('ecommerce_product_offer') + '/' + id[i])
                if (data.status) {
                    this._vm.$message.success(this._vm.$t('messages.deleteOk'))
                    successDeleted.push(id[i])
                } else {
                    this._vm.$message.error(data.message)
                }
            }
            dispatch('refresh')
            return successDeleted
        }
    },
}

const mutations = {
    setLoading(state, val) {
        state.table.loading = val
    },
    updatePagination(state, pagination) {
        state.table.pagination = pagination
    },
    updateTableData(state, data) {
        state.table.data = data
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
